// import { createRoot } from "react-dom/client";
import "@mantine/core/styles.css";

import "./index.css";
import App from "./App.tsx";
import { theme } from "@/theme";
import { MantineProvider } from "@mantine/core";
import { AppThemeProvider } from '@/contexts/brander.ctx.tsx';
export default function TesteeApp() {
  return (
    <MantineProvider theme={theme} defaultColorScheme="light">
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </MantineProvider>
  )
}
